import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Crewmate from "../components/Crewmate";

const UPDATED  = "25 февраля 2026 г.";
const OPERATOR = "ИП Кузина Татьяна Николаевна";
const EMAIL    = "kuzin.denison@gmail.com";
const SITE     = "neonparty.ru";

const Section = ({ title, children }) => (
  <section style={{ marginBottom: "2rem" }}>
    <div style={{ display: "flex", alignItems: "center", gap: "0.6rem", marginBottom: "0.85rem" }}>
      <div style={{
        background: "#00f5ff", border: "2.5px solid #000",
        borderRadius: "0.5rem", boxShadow: "2px 2px 0 #000",
        width: "0.5rem", height: "1.5rem", flexShrink: 0,
      }} />
      <h2 style={{
        fontFamily: "'Fredoka One', sans-serif", fontSize: "1.1rem",
        color: "#00f5ff", margin: 0,
      }}>{title}</h2>
    </div>
    <div style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.95rem", color: "#bbb", lineHeight: 1.8 }}>
      {children}
    </div>
  </section>
);

const Li = ({ children }) => (
  <li style={{ marginBottom: "0.4rem", paddingLeft: "0.25rem", listStyle: "none" }}>
    <span style={{ color: "#00f5ff", marginRight: "0.4rem" }}>▸</span>{children}
  </li>
);

export default function PrivacyPage() {
  const navigate = useNavigate();
  return (
    <div className="page-root" style={{ minHeight: "100vh", color: "#fff" }}>
      <Navbar />
      <div style={{ maxWidth: "780px", margin: "0 auto", padding: "3rem 1.5rem 5rem" }}>

        {/* Hero */}
        <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "1rem" }}>
            <Crewmate color="#00f5ff" size={52} animate="bounce" />
          </div>
          <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.8rem", color: "#444", marginBottom: "0.4rem" }}>
            Последнее обновление: {UPDATED}
          </p>
          <h1 style={{
            fontFamily: "'Fredoka One', sans-serif",
            fontSize: "clamp(1.8rem,5vw,2.75rem)",
            color: "#fff", lineHeight: 1.15,
            textShadow: "4px 4px 0 #00f5ff, 7px 7px 0 #000",
          }}>Политика конфиденциальности</h1>
        </div>

        {/* Content */}
        <div className="card-cartoon" style={{ padding: "2rem" }}>

          <Section title="1. Общие положения">
            <p>Настоящая Политика конфиденциальности определяет порядок обработки и защиты персональных данных пользователей сервиса {SITE}.</p>
            <br/>
            <p>Оператор персональных данных: <strong style={{color:"#fff"}}>{OPERATOR}</strong></p>
            <p>Контактный адрес: <strong style={{color:"#00f5ff"}}>{EMAIL}</strong></p>
            <br/>
            <p>Используя Сервис, вы соглашаетесь с условиями настоящей Политики. Политика разработана в соответствии с требованиями ФЗ-152 «О персональных данных».</p>
          </Section>

          <Section title="2. Какие данные мы собираем">
            <p>Сервис собирает минимально необходимый объём данных:</p>
            <br/>
            <ul style={{ padding: 0 }}>
              <Li><strong style={{color:"#fff"}}>Никнейм игрока</strong> — вводится самостоятельно, не является персональными данными.</Li>
              <Li><strong style={{color:"#fff"}}>IP-адрес</strong> — только для защиты от автоматического перебора. Не хранится дольше 1 часа.</Li>
              <Li><strong style={{color:"#fff"}}>Промокод</strong> — сохраняется в localStorage вашего браузера. На сервере — только факт использования без привязки к личности.</Li>
              <Li><strong style={{color:"#fff"}}>Технические данные</strong> — браузер, разрешение экрана (используются анонимно).</Li>
            </ul>
            <br/>
            <p>Мы <strong style={{color:"#ff3355"}}>не собираем</strong>: ФИО, email, номера телефонов, платёжные данные, геолокацию.</p>
          </Section>

          <Section title="3. Цели обработки данных">
            <ul style={{ padding: 0 }}>
              <Li>Обеспечение функциональности игровых сессий.</Li>
              <Li>Защита от злоупотреблений (rate limiting по IP).</Li>
              <Li>Улучшение качества Сервиса (анонимная аналитика).</Li>
            </ul>
          </Section>

          <Section title="4. Cookies и локальное хранилище">
            <ul style={{ padding: 0 }}>
              <Li><strong style={{color:"#fff"}}>Технические cookies</strong> — необходимы для работы WebSocket-соединения.</Li>
              <Li><strong style={{color:"#fff"}}>localStorage</strong> — хранение промокода и никнейма на вашем устройстве.</Li>
            </ul>
            <br/>
            <p>Мы <strong style={{color:"#fff"}}>не используем</strong> рекламные, аналитические или трекинговые cookies третьих сторон.</p>
          </Section>

          <Section title="5. Передача данных третьим лицам">
            <p>Мы не продаём, не передаём и не раскрываем ваши данные третьим лицам, за исключением случаев, предусмотренных законодательством РФ.</p>
          </Section>

          <Section title="6. Хранение данных">
            <ul style={{ padding: 0 }}>
              <Li>IP-адреса — не более 1 часа (только для rate limiting).</Li>
              <Li>Игровые сессии (никнеймы, очки) — до 7 дней, затем автоматически удаляются.</Li>
              <Li>Информация о промокодах — до истечения срока действия кода.</Li>
            </ul>
          </Section>

          <Section title="7. Права пользователей">
            <p>В соответствии с ФЗ-152 вы вправе:</p>
            <br/>
            <ul style={{ padding: 0 }}>
              <Li>Запросить информацию об обработке ваших данных.</Li>
              <Li>Потребовать удаления данных.</Li>
              <Li>Отозвать согласие на обработку данных.</Li>
            </ul>
            <br/>
            <p>Для реализации прав: <strong style={{color:"#00f5ff"}}>{EMAIL}</strong></p>
          </Section>

          <Section title="8. Безопасность">
            <p>Применяем: шифрование соединений (HTTPS/WSS), ограничение доступа к базе данных, регулярное обновление программного обеспечения.</p>
          </Section>

          <Section title="9. Несовершеннолетние">
            <p>Сервис предназначен для лиц старше 12 лет. Игры 18+ содержат контент только для совершеннолетних.</p>
          </Section>

          <Section title="10. Изменения Политики">
            <p>Актуальная версия всегда доступна на этой странице. Продолжение использования Сервиса означает согласие с новой редакцией.</p>
          </Section>

          <Section title="11. Контакты">
            <p>По вопросам конфиденциальности: <strong style={{color:"#00f5ff"}}>{EMAIL}</strong></p>
          </Section>

          {/* Footer */}
          <div style={{
            marginTop: "2rem", padding: "1rem 1.25rem",
            background: "#0d0820", border: "2px solid #000",
            borderRadius: "0.75rem", boxShadow: "2px 2px 0 #000",
            fontFamily: "'Nunito', sans-serif", fontSize: "0.78rem", color: "#444",
            textAlign: "center",
          }}>
            {OPERATOR} · ИНН 401900080185 · ОГРНИП 322402700054046<br/>
            Документ соответствует требованиям ФЗ-152 «О персональных данных».
          </div>
        </div>

        <div style={{ textAlign: "center", marginTop: "2rem" }}>
          <button onClick={() => navigate("/")} className="btn-cartoon btn-secondary" style={{ padding: "0.6rem 1.5rem" }}>
            ← На главную
          </button>
        </div>

      </div>
    </div>
  );
}